import clsx from "clsx";
import PropTypes from "prop-types";
import { Box, Icon, IconButton, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    flex: 1,
  },
  titleContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: 16,
  },
  addIcon: {
    width: "unset",
    height: "unset",
    overflow: "unset",
    fontSize: 16,
  },
  iconButtonAdd: {
    "&.Mui-disabled": {
      visibility: "hidden",
    },
  },
}));

const HeaderList = ({ title }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.titleContainer}>
        {title}
      </Box>
      <Box>
      </Box>
    </Box>
  );
};

HeaderList.defaultProps = {
};

HeaderList.propTypes = {
  title: PropTypes.node.isRequired,
};

export default HeaderList;
